import { enums } from "../utils/constants";
import create from "zustand";
import { legendsLevelNumber } from "../utils/legendsLevels";
import { worpelLevelNumber } from "../utils/worpelLevels";

async function fetchPlayers(url) {
  const data = await (await fetch(url)).json();
  return data;
}

async function fetchWorpelLevels() {
  try {
    const response = await fetch("json/worpel_levels.json");
    return await response.json();
  } catch (error) {
    console.error("Error fetching worpel levels:", error);
    return null;
  }
}

async function fetchLegendsLevels() {
  try {
    const response = await fetch("json/legends_levels.json");
    return await response.json();
  } catch (error) {
    console.error("Error fetching legends levels:", error);
    return null;
  }
}

const useGameStore = create((set, get) => ({
  target: null,
  setTarget: (player) => {
    // console.log(`set target = ${player.surname}`);
    set({ target: player });
  },

  levelNumber: null,
  setLevelNumber: (number) => {
    console.log(`set levelNumber = ${number}`);
    set({ levelNumber: number });
  },

  imgUrl: null,
  setImgUrl: (url) => set({ imgUrl: url }),

  initError: false,
  setInitError: (value) => set({ initError: value }),

  players: [],
  fetchWorpelPlayers: async () => {
    try {
      console.log("fetching worpel players");
      const players = await fetchPlayers("json/worpel.json");
      set({ players: players });
    } catch (error) {
      console.log(error.message);
    }
  },
  fetchLegendsPlayers: async () => {
    try {
      console.log("fetching legends players");
      const players = await fetchPlayers("json/legends.json");
      set({ players: players });
    } catch (error) {
      console.log(error.message);
    }
  },

  worpelLevelData: null,
  setWorpelLevelData: (data) => set({ worpelLevelData: data }),
  fetchWorpelLevelData: async () => {
    try {
      const levelData = await fetchWorpelLevels();
      set({ worpelLevelData: levelData });
      return levelData;
    } catch (error) {
      console.error("Error setting worpel level data:", error);
      set({ initError: true });
      return null;
    }
  },

  legendsLevelData: null,
  setLegendsLevelData: (data) => set({ legendsLevelData: data }),
  fetchLegendsLevelData: async () => {
    try {
      const levelData = await fetchLegendsLevels();
      set({ legendsLevelData: levelData });
      return levelData;
    } catch (error) {
      console.error("Error setting legends level data:", error);
      set({ initError: true });
      return null;
    }
  },

  game: null,
  setGame: (game) => set({ game: game }),

  analyticsGameName: "",
  setAnalyticsGameName: (name) => set({ analyticsGameName: name }),

  shareGameName: "",
  setShareGameName: (name) => set({ shareGameName: name }),

  shareGameUrl: "",
  setShareGameUrl: (url) => set({ shareGameUrl: url }),

  isSilhouetteOpen: false,
  setIsSilhouetteOpen: (isOpen) =>
    set((state) => ({ isSilhouetteOpen: isOpen })),

  isAnswerOpen: false,
  setIsAnswerOpen: (isOpen) => set((state) => ({ isAnswerOpen: isOpen })),

  isResultOpen: false,
  setIsResultOpen: (isOpen) => set((state) => ({ isResultOpen: isOpen })),

  levelResult: enums.levelResult.TBD,
  setLevelResult: (result) => set((state) => ({ levelResult: result })),

  setupWorpelLevel: async () => {
    get().setGame(enums.game.WORPEL);

    // Fetch level data if not already loaded
    let levelData = get().worpelLevelData;
    if (!levelData) {
      levelData = await get().fetchWorpelLevelData();
      if (!levelData) {
        get().setInitError(true);
        return;
      }
    }

    get().setLevelNumber(worpelLevelNumber);
    get().setAnalyticsGameName("Worpel");
    get().setShareGameName("Worpel");
    get().setShareGameUrl("https://playworpel.com");

    const targetId = levelData[worpelLevelNumber];
    if (!targetId) {
      get().setInitError(true);
      return;
    }

    const target = get().players[targetId];
    if (target) {
      get().setTarget(target);
      const imgUrl = `https://s.afl.com.au/staticfile/AFL%20Tenant/AFL/Players/ChampIDImages/AFL/2025014/${target.dataId}.png?i10c=img.resize(scale_height:0.6)`;
      get().setImgUrl(imgUrl);
      get().setInitError(false);
    } else {
      get().setInitError(true);
    }
  },

  setupLegendsLevel: async () => {
    get().setGame(enums.game.LEGENDS);

    // Fetch level data if not already loaded
    let levelData = get().legendsLevelData;
    if (!levelData) {
      levelData = await get().fetchLegendsLevelData();
      if (!levelData) {
        get().setInitError(true);
        return;
      }
    }

    get().setLevelNumber(legendsLevelNumber);
    get().setAnalyticsGameName("Legends");
    get().setShareGameName("Legends");
    get().setShareGameUrl("https://playworpel.com/legends");

    const targetId = levelData[legendsLevelNumber];
    if (!targetId) {
      get().setInitError(true);
      return;
    }

    const target = get().players[targetId];
    if (target) {
      get().setTarget(target);
      const imgUrl = `https://s.afl.com.au/staticfile/AFL%20Tenant/AFL/Players/ChampIDImages/AFL/${target.lastSeason}014/${target.dataId}.png`;
      get().setImgUrl(imgUrl);
      get().setInitError(false);
    } else {
      get().setInitError(true);
    }
  },

  clearState: () => {
    console.log("clearing state");
    set((state) => ({
      target: null,
      players: [],
      isSilhouetteOpen: false,
      isAnswerOpen: false,
      isResultOpen: false,
      levelResult: enums.levelResult.TBD,
    }));
  },
}));

export default useGameStore;
